import React, { useEffect } from 'react';

import CheckCircle from '../../../../assets/icons/check-circle.svg';
import ButtonComponent from '../../../Button';

import { useDispatch } from 'react-redux';
import { navigationUrl } from '../../../../store/analytic/actions';
import { Content } from './styles';

export interface IDetails {
  title: string;
  subtitle: string;
  detail: string;
  datehour: string;
}
interface IReceiveCall {
  handlerClose: () => void;
  verification: string;
  details: IDetails;
}

const FinishCall: React.FC<IReceiveCall> = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: props.verification
          ? '/confirmaReceberLigacaoAgora'
          : '/confirmaAgendarLigacao',
      }),
    );
  }, [dispatch, props.verification]);

  return (
    <Content>
      <img className='checkcircle' src={CheckCircle} alt='' />
      <span className='title'>{props.details.title}</span>
      <p className='description'>{props.details.subtitle}</p>
      <div className='details'>
        <p>{props.details.detail}</p>
        <span>{props.details.datehour}</span>
      </div>
      <div className='btn_finish'>
        <ButtonComponent
          height={60}
          onClick={props.handlerClose}
          children={<p>CONCLUIR</p>}
          color={'primary'}
          fontSize={'16'}
          borderRadios={'16'}
        />
      </div>
    </Content>
  );
};

export default FinishCall;
